/**
 * MVP Event Configuration
 *
 * For the first event, the active event_id and slug are fixed here as a
 * single config constant. All three apps (Participant PWA, Scanner App,
 * Command Center) should import from this file during bootstrap.
 *
 * TODO (event #2 unhardcode point): Replace this with a runtime lookup
 * from the URL, a query param, or a staff-select UI in the Command Center.
 * The schema and API are already multi-event - only this config needs to change.
 *
 * Task 6.4 - Requirement 1.1, 1.5
 */

/**
 * The slug of the currently active event.
 * Resolved via GET /api/events/:slug on app bootstrap.
 * All API calls that need event_id should derive it from the resolved event object.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ACTIVE_EVENT_SLUG = (import.meta as any).env?.VITE_ACTIVE_EVENT_SLUG || 'event-2026';

/**
 * Polling interval in milliseconds for dashboard and wallet views.
 * Keeps the backend load predictable at MVP scale (Req 19.6).
 */
export const POLLING_INTERVAL_MS = 15_000;

/**
 * Polling interval for Kill Switch / registration open status (Req 13.2).
 */
export const REGISTRATION_STATUS_POLL_MS = 20_000;
